
import { Vue, Component, Prop } from "vue-property-decorator";
import ActivityFormModal from "@/components/projects/activities/ActivityFormModalNew.vue";
import { Project } from "@/interface";
import TagIcon from "@/components/icons/TagIconNew.vue";
import EditIconHover from "@/components/icons/EditIconHover.vue";
import { Project_Activity } from "@/generated/graphql";
import UiButton from "@/components/button/ui-button.vue";
import RouteNames from "@/entities/RouteNames";

@Component({
  components: {
    UiButton,
    ActivityFormModal,
    TagIcon,
    EditIconHover,
  },
})
export default class AddTaskAction extends Vue {
  @Prop({ type: String, required: true }) readonly currentUserRole!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: String, default: "" }) readonly size!: string;
  @Prop({ type: String, required: true, default: true })
  readonly isIcon!: string;
  @Prop({ type: Object, required: false }) readonly project!: Project;
  @Prop({ type: Object, default: undefined, required: false })
  readonly projectId?: string;
  @Prop({ type: Object, default: undefined })
  readonly projectActivity?: Project_Activity;
  @Prop({ type: String, default: undefined }) readonly contractorId?: string;
  @Prop({ type: Boolean, default: false })
  readonly redirectToDetails!: boolean;

  modalShown: boolean = false;
  isHovered: boolean = false;

  get buttonText(): string {
    if (this.projectActivity) {
      return "Edit Task";
    }

    return "Add Task";
  }

  showModal(): void {
    this.modalShown = true;
  }

  hideModal(): void {
    this.modalShown = false;
  }

  onActivityAdded(): void {
    this.modalShown = false;

    this.$router.push({
      name: RouteNames.PROJECT_ACTIVITY,
      params: {
        id: this.project.id!,
      },
    });
  }
}
